import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";

import { PageAlert } from "capitalrx-components";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { planGetActions } from "@/App/actions";

export function* getPlan(payload: {}): Generator {
  return yield apiService({
    url: "/plan/get",
    method: "POST",
    data: payload,
  });
}

export function* getPlanWorker(action: ReturnType<typeof planGetActions.getPlan>): SagaIterator {
  const { getPlanFailure, getPlanSuccess } = planGetActions;
  const { payload } = action;
  const { showPageAlert } = PageAlert;

  try {
    const plan = yield call(getPlan, payload);
    yield put(getPlanSuccess(plan));
  } catch (error) {
    const { data: { message = "" } = {} } = error;
    yield put(getPlanFailure());
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

export default function* getPlanWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.GET_PLAN, getPlanWorker);
}
